<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="60%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div class="col-md-6 col-lg-6 col-xl-2">
            <fg-input
              type="text"
              :label="`${$t('common_words.code')}: *`"
              name="common_words.code"
              v-model="model.code"
              placeholder="..."
              v-validate="modelValidations.code"
              :error="getError('common_words.code', true)"
              @click="handleClickOnCode('sowing.seed_type')"
            >
            </fg-input>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-4">
            <div class="form-group has-label">
              <label for="">{{ $t('common_words.size') }}: *</label>
              <br />
              <el-select
                clearable
                filterable
                class="select-primary mb-3 shadow-sm required-size"
                v-model="model.size"
                :placeholder="`${$t('common_words.select2')}...`"
              >
                <el-option
                  class="select-primary"
                  v-for="item in size"
                  :key="item.id + item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-12 col-lg-12 col-xl-6">
            <fg-input
              type="text"
              :label="`${$t('common_words.name')}: *`"
              v-model="model.name"
              name="common_words.name"
              v-validate="modelValidations.name"
              :error="getError('common_words.name', true)"
              placeholder=" ..."
            >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <select-businesses-component
              ref="selectBusiness"
              :showLoading="true"
              :requiered="true"
              :initialData="businessesInitial"
              @onChange="updateSelectedBusinesses"
              @showHideLoading="showHideLoading"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12">
            <div class="form-group has-label">
              <label>{{ $t('common_words.description') }}: </label>
              <br />
              <el-input
                maxlength="300"
                show-word-limit
                class="shadow-sm"
                type="textarea"
                :rows="3"
                v-model="model.description"
                :placeholder="$t('sowing.seed_description_enter')"
              >
              </el-input>
            </div>
          </div>
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import i18n from 'src/i18n';

export default {
  name: 'edit-create',
  mixins: [MixinDialog, MixinForm, MixinValidations, MixinLoading],
  data() {
    return {
      disabledField: false,
      model: {
        name: null,
        code: null,
        size: null,
        description: null,
        businesses_id: [],
        businesses_names: [],
      },
      businessesInitial: [],
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
        size: {
          required: true,
        },
      },
    };
  },
  computed: {
    size() {
      return [
        { id: 'pequeña', value: i18n.t('common_words.small') },
        { id: 'mediana', value: i18n.t('common_words.medium') },
        { id: 'grande', value: i18n.t('common_words.big') },
      ];
    },
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.size)) {
            return this.validationInputsRequired('size');
          }
          if (this.model.businesses_id.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }

            return false;
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);

      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
